import React,{useState,useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import M from 'materialize-css'
import {API} from '../../api'

const CreatePost = () =>{
    const history =  useHistory("")
    const [title,setTitle] = useState("")
    const [body,setBody] = useState("")
    const [image,setImage] = useState("")
    const [url,setUrl] = useState("")
    useEffect(()=>{
        if(url){
            console.log(""+url)
            fetch(`${API}/createpost`,{
                method:"post",
                headers:{
                    "Content-Type":"application/json",
                    "Authorization":"Bearer "+localStorage.getItem("jwt")
                },
                body:JSON.stringify({
                    title,
                    body,
                    photo:url
                })
            }).then(res=>
                res.json()
                )
            .then(data=>{
               if(data.error){
                   M.toast({html:data.error,classes:"#b71c1c red darken-4"})
               }
               else{
                   M.toast({html:"Created Successfully",classes:"#43a047 green darken-1"})
                   history.push('/')
               }
            }).catch(err=>{
                console.log(err)
        })
        }
    },[url])
    const postDetails=()=>{
        const data = new FormData()
        data.append("file",image)
        data.append("upload_preset","instagram_clone")
        data.append("cloud_name","dctq1stjk")
        fetch("	https://api.cloudinary.com/v1_1/dctq1stjk/image/upload/",{
            method:"post",
            body:data
        })
        .then(res=>res.json())
        .then(data=>{
            console.log(data)
            setUrl(data.url)
            console.log(data.url)
        })
        .catch(err=>{
            console.log(err)
        })
    



    }
    return(
        <div className="mycard">
            <div className="card auth-card input-field">
                <h2 className="brand-logo">Minsta</h2>
                <input type="text" placeholder="Title" value={title} onChange={(e)=>setTitle(e.target.value)}></input>
                <input type="text" placeholder="Body" value={body} onChange={(e)=>setBody(e.target.value)}></input>
                <div className="file-field input-field">
                    <div className="btn">
                        <span>File</span>
                        <input type="file" onChange={(e)=>setImage(e.target.files[0])}/>
                    </div>
                    <div className="file-path-wrapper">
                        <input className="file-path validate" type="text" placeholder="Image" />
                    </div>
                    </div>
                <button className="btn waves-effect waves-light" onClick={()=>postDetails()}>Create Post
                 </button>
            </div>
        </div>
    )
}

export default CreatePost